import media from 'modules/media';
import styled from 'styled-components';

import {
  black,
  blue,
  green,
  lightGray,
  lightGreen,
  mediumGray,
  orange,
  purple,
  red,
  white,
  yellow,
} from '../../modules/colors';
import { fonts, spacing } from '../../modules/metrics';

const options = {
  black,
  blue,
  mediumGray,
  green,
  lightGray,
  lightGreen,
  orange,
  purple,
  red,
  yellow,
};

export const Wrapper = styled.span`
  ${(props) => props.color && `background-color: ${options[props.color]};`};
  color: ${white};
  border-radius: 16px;
  font-size: ${fonts.xs}px;
  padding: ${spacing.sm}px ${spacing.lg}px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  white-space: nowrap;
  ${(props) => props.onClick && 'cursor: pointer;'};
  ${(props) => props.onClick && props.unSelected && 'opacity: 0.5;'};

  ${media.phone} {
    padding: ${spacing.sm}px ${spacing.md}px;
  }
`;
